import { render, staticRenderFns } from "./CbsDataObject.vue?vue&type=template&id=1c817422&scoped=true"
import script from "./CbsDataObject.vue?vue&type=script&lang=js"
export * from "./CbsDataObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c817422",
  null
  
)

export default component.exports